import { forwardRef, useCallback } from "react";
import { useUniqueId } from "../Utils/uniqueId";

import FeaturedContentBlock from "./FeaturedContentBlock";

const FeaturedContentCarouselSlide = (props, ref) => {
  const { blocks, slideIndex, setIsSlideFocused } = props;

  const id = useUniqueId("featured-content-slide-");

  const handleSlideFocused = useCallback(() => {
    setIsSlideFocused(true);
  }, [setIsSlideFocused]);

  const handleSlideBlurred = useCallback(() => {
    setIsSlideFocused(false);
  }, [setIsSlideFocused]);

  const refWithSlideIndex = useCallback(
    element => {
      if (ref) ref(element, slideIndex);
    },
    [ref, slideIndex]
  );

  return (
    <ul
      id={id}
      className="d-flex content-slide slide-container list-unstyled w-100"
      ref={refWithSlideIndex}
      onFocus={handleSlideFocused}
      onBlur={handleSlideBlurred}
    >
      {blocks.map(block => (
        <FeaturedContentBlock key={block.id} block={block} />
      ))}
    </ul>
  );
};

export default forwardRef(FeaturedContentCarouselSlide);
